export default __webpack_public_path__ + "static/tweet-two-2852cddb211173d9ecc21e26b43f1155.png";